import * as THREE from 'three';

// Small helpers shared by every scene and entity, so we build geometry the same
// way everywhere. All meshes cast + receive shadows by default.

export function mat(color){ return new THREE.MeshLambertMaterial({ color }); }

export function box(w, h, d, color, x, y, z, parent){
  const m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat(color));
  m.position.set(x, y, z);
  m.castShadow = m.receiveShadow = true;
  if (parent) parent.add(m);
  return m;
}

export function cyl(rt, rb, h, color, x, y, z, parent, seg = 20){
  const m = new THREE.Mesh(new THREE.CylinderGeometry(rt, rb, h, seg), mat(color));
  m.position.set(x, y, z);
  m.castShadow = m.receiveShadow = true;
  if (parent) parent.add(m);
  return m;
}

export function sphere(r, color, x, y, z, parent, seg = 14){
  const m = new THREE.Mesh(new THREE.SphereGeometry(r, seg, seg), mat(color));
  m.position.set(x, y, z);
  m.castShadow = m.receiveShadow = true;
  if (parent) parent.add(m);
  return m;
}

export function torus(r, tube, color, x, y, z, parent, rt = 12, tt = 8){
  const m = new THREE.Mesh(new THREE.TorusGeometry(r, tube, tt, rt), mat(color));
  m.position.set(x, y, z);
  m.castShadow = m.receiveShadow = true;
  if (parent) parent.add(m);
  return m;
}

// A world-space text sprite (speech bubbles, floating rewards, signage).
export function textSprite(txt, size, cssColor, wScale = 1.4, hScale = 0.7){
  const cv = document.createElement('canvas');
  cv.width = 256; cv.height = 128;
  const g = cv.getContext('2d');
  g.fillStyle = cssColor;
  g.font = `bold ${size}px "Space Grotesk", sans-serif`;
  g.textAlign = 'center';
  g.textBaseline = 'middle';
  g.fillText(txt, 128, 64);
  const tex = new THREE.CanvasTexture(cv);
  const sp = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, transparent: true }));
  sp.scale.set(wScale, hScale, 1);
  return sp;
}

// Easing used across animations.
export const clamp01 = t => Math.max(0, Math.min(1, t));
export const ease = t => (t < .5 ? 2*t*t : -1 + (4 - 2*t)*t);

export function angleLerp(a, b, t){
  let d = (b - a) % (Math.PI * 2);
  if (d >  Math.PI) d -= Math.PI * 2;
  if (d < -Math.PI) d += Math.PI * 2;
  return a + d * t;
}
